import { useEffect, useState } from 'react'

export function useToolbarPosition(
  containerRef: React.RefObject<HTMLElement>,
  offsetBottom: number = 50,
) {
  const [toolbarStyle, setToolbarStyle] = useState<React.CSSProperties>({})

  useEffect(() => {
    const updatePosition = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect()
        setToolbarStyle({
          position: 'fixed',
          bottom: offsetBottom,
          left: rect.left,
          width: rect.width,
        })
      }
    }

    const raf = requestAnimationFrame(updatePosition)

    window.addEventListener('resize', updatePosition)
    window.addEventListener('scroll', updatePosition)

    return () => {
      cancelAnimationFrame(raf)
      window.removeEventListener('resize', updatePosition)
      window.removeEventListener('scroll', updatePosition)
    }
  }, [containerRef, offsetBottom])

  return toolbarStyle
}
